(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["minicart"]) return;
  try {
    
class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.head = this.querySelector('.head');
    this.body = this.querySelector('.body');
    this.foot = this.querySelector('.foot');
    this.sizes = {
      'XS': 'X-Small',
      'S': 'Small',
      'M': 'Medium',
      'L': 'Large',
      'XL': 'X-Large',
      'XXL': 'XX-Large',
      '3XL': '3X-Large'
    };
    this.max = 18;
  }
  connectedCallback() {
    var self = this;
    this.cart = null;
    getCart()
      .then(function(res) {
        self.cart = res;
        self.renderStatus(res.item_count);
        self.renderItems(res.items);
        self.renderTotal(res.items_subtotal_price, res.currency);
      })
      .catch(function (e) {
        console.warn(e);
      });
    this.querySelector('.cartClose').addEventListener('click', function() {
      self.close();
    })
  }
  open() {
    console.log('mini cart open');
    document.body.classList.add('overlay');
    this.classList.add('open');
  }
  close() {
    document.body.classList.remove('overlay');
    this.classList.remove('open');
  }
  renderStatus(num) {
    var remaining = this.max - num;
    this.foot.querySelector('.count').innerHTML = remaining + '/' + this.max;
  }
  renderItems(items) {
    var self = this;
    trunkFirst(items);
    var rows = '<ul>';
    items.map(function(row) {
      rows += '<li><div class="image">';
      rows += '<img src="' + row.image + '">';
      rows += '</div>';
      rows += '<div class="text">';
      rows += '<h4>' + row.title + '</h4>';
      if (row.variant_title) rows += '<div class="size">' + self.sizes[row.variant_title] + '</div>';
      rows += '</div>';
      rows += '</li>';
    });
    rows += '</ul>';
    this.body.insertAdjacentHTML("afterbegin", rows);
  }
  renderTotal(total, currency) {
    var symbol = currency === "USD" ? "$" : "£";
    var moneyFormat = total/100;
    this.foot.querySelector('.subtotal').innerHTML = symbol + moneyFormat;
  }
}

customElements.define("mini-cart", MiniCart);

  } catch(e) { console.error(e); }
})();
      })();
